export interface Season {
    id: number;
    name: string;
    date_start: string;
    date_end: string;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptySeason: Season = {
    id: 0,
    name: '',
    date_start: '',
    date_end: '',
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}